import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { HomeAddressState, homeAddressCurrentFeatureKey } from '../reducers/home-address-current.reducer';
import * as homeAddressState from '../reducers/home-address-current.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, HomeAddressState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Home Address SUB STATE
export const getHomeAddressState = createSelector(getMainEmployeeState, state => state[homeAddressCurrentFeatureKey]);
//#endregion

//#region  Home Address SUB STATE
export const getIsHomeAddressRequest = createSelector(getHomeAddressState, homeAddressState.getHomeAddressRequest);
export const getIsHomeAddressSuccess = createSelector(getHomeAddressState, homeAddressState.getHomeAddressResponse);
export const getIsHomeAddressFailure = createSelector(getHomeAddressState, homeAddressState.getHomeAddressFailure);
//#endregion
